// app/javascript/controllers/image_preview_controller.js
import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="image_preview"
export default class extends Controller {
  static targets = ["preview", "removeButton", "removeField"];

  preview(event) {
    let file = event.target.files[0];
    let reader = new FileReader();

    reader.onload = () => {
      this.previewTarget.src = reader.result;
      this.previewTarget.classList.remove("hidden");
      this.removeButtonTarget.classList.remove("hidden");
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  }

  remove(event) {
    event.preventDefault();
    const container = event.target.closest("[data-controller='image_preview']");
    const input = container.querySelector("input[type='file']");

    input.value = "";
    this.previewTarget.src = "";

    this.previewTarget.classList.add("hidden");
    this.removeButtonTarget.classList.add("hidden");
  }

  removeExisting(event) {
    event.preventDefault();
    if (this.hasRemoveFieldTarget) {
      this.removeFieldTarget.value = "1";
    }
    this.element.classList.add("hidden");
  }
}
